<template>
  <FaIcon
    v-if="count > 0"
    name="paperclip"
    variant="light"
    :title="count === 1 ? '1 Dokument' : `${count} Dokumente`"
    class="my-0.5"
  />
</template>

<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';

defineProps<{ count: number }>();
</script>
